import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import {ownerRouteRedirect} from '@/models/owner-report-state';

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: '/home',
        name: 'HomeView',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: "/login",
        name: "LoginView",
        component: () => import("../views/public/LoginView.vue"),
    },
    {
        path: "/change-profile",
        name: "ChangeProfileView",
        component: () => import("../views/admin/setting/ChangeProfileView.vue"),
    },

    // ADMIN
    {
        path: '/admin-sistem',
        name: 'AdminSistemView',
        component: () => import('../views/admin/setting/UserView.vue')
    },
    {
        path: '/admin-struktur-organisasi-sistem',
        name: 'AdminStrukturSistemView',
        component: () => import('../views/admin/setting/StrukturSistemView.vue')
    },
    {
        path: '/admin-setting',
        name: 'AdminSetting',
        component: () => import('../views/admin/setting/SettingView.vue')
    },
    {
        path: '/cust-region',
        name: 'AdminWilayahView',
        component: () => import('../views/admin/mitra/WilayahView.vue')
    },
    {
        path: '/customer-old',
        name: 'AdminCustomerOld',
        component: () => import('../views/admin/mitra/CustomerView.vue')
    },
    {
        path: '/customer-new',
        name: 'AdminCustomerNewView',
        component: () => import('../views/admin/mitra/NewCustomerView.vue')
    },
    {
        path: '/customer-new-detil/:id',
        name: 'AdminCustomerNewDetilView',
        component: () => import('../views/admin/mitra/CustomerDetilView.vue')
    },

    {
        path: '/product-sales-chart-brand',
        name: 'AdminSalesBrandView',
        component: () => import('../views/admin/product/SalesBrandView.vue')
    },
    {
        path: '/admin-master-tax',
        name: 'AdminTaxView',
        component: () => import('../views/admin/product/TaxView.vue')
    },
    {
        path: '/cust-category',
        name: 'AdminCustCategoryView',
        component: () => import('../views/admin/mitra/KategoriView.vue')
    },
    {
        path: '/product-category',
        name: 'AdminProductGroupView',
        component: () => import('../views/admin/product/MaterialGroupView.vue')
    },
    {
        path: '/pegawai',
        name: 'SalesmanView',
        component: () => import('../views/admin/sales/SalesmanView.vue')
    },
    {
        path: '/sales-call-plan',
        name: 'SalesCallPlanView',
        component: () => import('../views/admin/sales/CallPlanView.vue')
    },
    {
        path: '/sales-call-plan-detil/:id',
        name: 'SalesCallPlanDetilView',
        component: () => import('../views/admin/sales/CallPlanDetilView.vue')
    },
    {
        path: '/sales-call-activity',
        name: 'SalesCallActivityView',
        component: () => import('../views/admin/sales/CallActView.vue')
    },
    {
        path: '/sales-call-new-outlet-order',
        name: 'SalesCallNewOutletOrder',
        component: () => import('../views/admin/sales/SalesCallNewOutletOrder.vue')
    },

    {
        path: '/supplier',
        name: 'VendorView',
        component: () => import('../views/admin/mitra/VendorView.vue')
    },
    {
        path: '/product',
        name: 'MaterialView',
        component: () => import('../views/admin/product/MaterialView.vue')
    },
    {
        path: '/warehouse',
        name: 'WarehouseView',
        component: () => import('../views/admin/inventory/WarehouseView.vue')
    },
    {
        path: '/mobile-order-entry',
        name: 'CloudMobileView',
        component: () => import('../views/admin/cloud-mobile/CloudMobileView.vue')
    },
    {
        path: '/export-cloud-sales-chart-order',
        name: 'ExportOrderView',
        component: () => import('../views/admin/cloud-mobile/ExportOrderView.vue')
    },
    {
        path: '/sales-order-invoice',
        name: 'OrderInvoiceView',
        component: () => import('../views/admin/sales/OrderInvoiceView.vue')
    },
    {
        path: '/purchase-order',
        name: 'PurchaseOrderView',
        component: () => import('../views/admin/purchase/PurchaseOrderView.vue')
    },
    {
        path: '/purchase-gr',
        name: 'GoodReceiptView',
        component: () => import('../views/admin/purchase/GoodReceiptView.vue')
    },
    {
        path: '/saldo-stock',
        name: 'AdminSaldoStock',
        component: () => import('../views/admin/inventory/StockView.vue')
    },
    {
        path: '/warning-stock',
        name: 'AdminWarningStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/summary-lp3',
        name: 'SummaryLP3',
        component: () => import('../views/admin/inventory/SummaryLp3View.vue')
    },
    {
        path: '/accounting/mutasi-hpp-cogs',
        name: 'MutasiHppCogsView',
        component: () => import('../views/admin/accounting/MutasiHppCogsView.vue')
    },
    {
        path: '/accounting/mutasi-akun',
        name: 'AccountMutationView',
        component: () => import('../views/admin/accounting/AccountMutationView.vue')
    },
    {
        path: '/accounting/journal-memorial',
        name: 'JournalMemorialView',
        component: () => import('../views/admin/accounting/JournalMemorialView.vue')
    },
    {
        path: '/cash-bank/deposit',
        name: 'DepositView',
        component: () => import('../views/admin/cashbank/DepositView.vue')
    },
    {
        path: '/cash-bank/payment',
        name: 'PaymentView',
        component: () => import('../views/admin/cashbank/PaymentView.vue')
    },
    {
        path: '/cash-bank/mutasi-bank',
        name: 'MutasiBankView',
        component: () => import('../views/admin/cashbank/MutasiBankView.vue')
    },
    {
        path: '/cash-bank/uang-muka',
        name: 'UangMukaView',
        component: () => import('../views/admin/cashbank/UangMukaView.vue')
    },
    {
        path: '/cash-bank/pencairan-giro',
        name: 'PencairanGiroView',
        component: () => import('../views/admin/cashbank/PencairanGiroView.vue')
    },

    {
        path: '/accounting/pnl-gross-sales',
        name: 'PnlGrossSalesView',
        component: () => import('../views/admin/accounting/PnlGrossSalesView.vue')
    },

    {
        path: '/umur-stock',
        name: 'AdminUmurStock',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/tax-keluaran',
        name: 'AdminTaxKeluaran',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/sales-chart-delivery',
        name: 'AdminSalesDelivery',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/export-sales-chart-detil',
        name: 'ExportSalesDetil',
        component: () => import('../views/admin/sales/ExportSalesDetilView.vue')
    },
    {
        path: '/sales/monitoring-piutang',
        alias: '/monitoring-piutang',
        name: 'MonitoringPiutangView',
        component: () => import('../views/admin/sales/MonitoringPiutangView.vue')
    },
    {
        path: '/sales-chart-summary-product',
        name: 'AdminSalesSummaryProduct',
        component: () => import('../views/admin/utils/UnderConstructionView.vue')
    },
    {
        path: '/log-exim',
        name: 'AdminLogEximView',
        component: () => import('../views/admin/cloud-mobile/LogEximView.vue')
    },
    {
        path: '/sastro-log-ext-check',
        name: 'SastroLogExtCheckView',
        component: () => import('../views/admin/cloud-mobile/SastroLogExtCheckView.vue')
    },

    {
        path: '/dashboard-utama',
        name: 'DashboardAdminDashboardUtama',
        component: () => import('../views/admin/dashboard/DashboardView.vue')
    },
    {
        path: '/owner-reports',
        name: 'OwnerReportsView',
        component: () => import('../views/admin/dashboard/OwnerReportsView.vue')
    },
    {
        path: '/accounting/finance-planning',
        alias: '/finance-planning',
        name: 'FinancePlanningView',
        component: () => import('../views/admin/accounting/FinancePlanningView.vue')
    },
    {
        path: '/accounting/audit',
        name: 'AccountingAuditView',
        component: () => import('../views/admin/accounting/AccountingAuditView.vue')
    },
    {
        path: '/accounting/checkpoints',
        name: 'AccCheckpointView',
        component: () => import('../views/admin/accounting/AccCheckpointView.vue')
    },
    {
        path: '/dashboard-acc-finance',
        name: 'DashboardAccFinanceView',
        component: () => import('../views/admin/dashboard/DashboardAccFinanceView.vue')
    },
    {
        path: '/dashboard-acc-finance-detail',
        name: 'DashboardAccFinanceDetailView',
        component: () => import('../views/admin/dashboard/DashboardAccFinanceView.vue')
    },

    {
        path: '/dashboard-sales-list',
        name: 'DashboardAdminSalesListView',
        component: () => import('../views/admin/dashboard/SalesListView.vue')
    },
    {
        path: '/dashboard-salesman-performance',
        name: 'DashboardAdminSalesmanPerformanceView',
        component: () => import('../views/admin/dashboard/SalesmanPeformanceView.vue')
    },
    {
        path: '/dashboard-division-performance',
        name: 'DashboardAdminDivisionPerformanceView',
        component: () => import('../views/admin/dashboard/DivisionPeformanceView.vue')
    },
    {
        path: '/dashboard-ar-persalesman',
        name: 'DashboardArPerSalesmanView',
        component: () => import('../views/admin/dashboard/ArPerSalesmanView.vue')
    },

    {
        path: '/analisis-ldh-cash-analisis',
        name: 'LdhCashAnalisisView',
        component: () => import('../views/admin/distributor-analisis/LdhCashAnalisisView.vue')
    },
    {
        path: '/smart-toolkit/des-lama',
        name: 'SmartToolkitDesLamaView',
        component: () => import('@/views/admin/smart-toolkits/DesLamaView.vue')
    },
    {
        path: '/smart-toolkit/sync-to-main-server',
        name: 'SmartToolkitSyncToMainServerView',
        component: () => import('@/views/admin/smart-toolkits/SyncToMainServerView.vue')
    },
    {
        path: '/smart-toolkit/sastro-integration-interface',
        name: 'SmartToolkitSastroIntegrationView',
        component: () => import('@/views/admin/smart-toolkits/SastroIntegration.vue')
    },

    {
        path: '/public-peta-sales-call',
        name: 'PetaPersebaranView',
        component: () => import('../views/public/PetaSalesCallView.vue')
    },
    {
        path: '/public-peta-sales-call-failed',
        name: 'PetaSalesCallFailedView',
        component: () => import('../views/public/PetaSalesCallFailedView.vue')
    },


];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(to => ownerRouteRedirect(store.state.auth.user, to.path) || undefined);

export default router;
